// start product image hover
(function() {
  const DEBUG = false;
  function log(...args){ if(DEBUG) console.log('[hover-swap]', ...args); }

  // don't init twice
  if (window._slideshowHoverSwapInit) {
    log('already initialized');
    return;
  }
  window._slideshowHoverSwapInit = true;

  // store original index per component
  const origIndexMap = new WeakMap();

  function isMousePointer(e){
    // pointer events on touch devices often have pointerType 'touch'; ignore those
    return !e.pointerType || e.pointerType === 'mouse';
  }

  function findSlideshow(el){
    return el && el.closest ? el.closest('slideshow-component') : null;
  }

  function handlePointerOver(e){
    if (!isMousePointer(e)) return;

    const comp = findSlideshow(e.target);
    if (!comp) return;

    // don't treat moving between elements inside the same comp as entry
    const from = e.relatedTarget;
    if (from && comp.contains(from)) return;

    if (origIndexMap.has(comp)) {
      // already in hover-mode for this comp
      return;
    }

    // ensure component has at least 2 slides
    const slides = comp.querySelectorAll('[slide-id]');
    if (!slides || slides.length < 2) return;

    // save current index (if component not ready, default to 0)
    const currentIndex = (typeof comp.current === 'number') ? comp.current : 0;
    origIndexMap.set(comp, currentIndex);

    // choose the index to show on hover: next if available else previous (fallback)
    const nextIndex = (currentIndex + 1 < slides.length) ? currentIndex + 1
                    : (currentIndex - 1 >= 0) ? currentIndex - 1
                    : currentIndex;

    try {
      if (typeof comp.select === 'function') {
        comp.select(nextIndex, null, { animate: false });
      }
    } catch (err) {
      log('error calling select on hover-in', err);
    }
  }

  function handlePointerOut(e){
    if (!isMousePointer(e)) return;

    const comp = findSlideshow(e.target);
    if (!comp) return;

    // don't treat moves within component as leave
    const to = e.relatedTarget;
    if (to && comp.contains(to)) return;

    if (!origIndexMap.has(comp)) return; // nothing to restore

    const orig = origIndexMap.get(comp);
    origIndexMap.delete(comp);

    try {
      if (typeof comp.select === 'function') {
        comp.select(orig, null, { animate: false });
      }
    } catch (err) {
      log('error calling select on hover-out', err);
    }
  }

  // Use capture to catch events early (robust for complex DOM)
  document.addEventListener('pointerover', handlePointerOver, true);
  document.addEventListener('pointerout', handlePointerOut, true);

  // Fallback: if new components are added and initial pointer events don't catch,
  // ensure comp.select works by trying to trigger once when component appears.
  // Observe DOM for slideshow-components (lightweight).
  const mo = new MutationObserver((mutations, obs) => {
    // if at least one slideshow-component present, we can stop observing after a while
    if (document.querySelector('slideshow-component')) {
      log('slideshow-component found by observer');
      // keep observing (we want to handle future additions). No disconnect.
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
});

// end product image hover

function waitForjQuery(callback) {
    if (typeof jQuery !== 'undefined') {
        // jQuery is available
        callback();
    } else {
        // jQuery is not loaded yet, check again after 100ms
        setTimeout(function() {
            waitForjQuery(callback);
        }, 100);
    }
}
function waitForSlick(object,callback) {
    if (typeof $.fn.slick === 'function') {
        // jQuery is available
        callback();
    } else {
        // jQuery is not loaded yet, check again after 100ms
        setTimeout(function() {
            waitForSlick(object,callback);
        }, 50);
    }
}

//Returns the gallery to its server-rendered markup. Called before a variant morph so the DOM
//diff compares plain markup instead of Slick's tracks, cloned slides and inline transforms.
function product_gallery_teardown(){

  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick !== 'function') return;

  if ($(".slider-for").hasClass("slick-initialized")) {
    $(".slider-for").slick("unslick");
  }
  if ($(".slider-nav").hasClass("slick-initialized")) {
    $(".slider-nav").slick("unslick");
  }

}

//this code uses for product detail page under product gallery
function product_gallery(){

  waitForjQuery(function() {
    // Wait for the Slick plugin to finish loading before initializing.
    // jQuery and slick.js are both deferred, so jQuery can be ready while
    // $.fn.slick is still undefined.
    waitForSlick($(".slider-for"), function() {

    if ($(".slider-for").hasClass("slick-initialized")) {
      $(".slider-for").slick("unslick");
    }
    if ($(".slider-nav").hasClass("slick-initialized")) {
      $(".slider-nav").slick("unslick");
    }

    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      fade: true,
    });

    $(".slider-nav").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: ".slider-for",
      dots: false,
      infinite: false,
      autoplay: false,
      focusOnSelect: true,
      responsive: [
          {
          breakpoint: 550,
          settings: {
              slidesToShow: 3,
          },
          },
          {
          breakpoint: 767,
          settings: {
              slidesToShow: 5,
          },
          },
          
          {
          breakpoint: 1200,
          settings: {
              slidesToShow: 3,
          },
          },
      ],
    });
    });
  })

}